import { useEffect, useState } from "react";
import PhotoZoom from "./photoZoom";
import { getImages } from "../services/studentWorkImagesService";

interface ISelectedImage {
    img: string;
    index: number;
}
const StudentWork = () => {
    const [photos, setPhotos] = useState<Array<any>>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState<ISelectedImage | undefined>();

    useEffect(() => { 
        window.scrollTo(0, 0);
        if (photos.length === 0 && getImages().length > 0)
            setPhotos(getImages());
    }, [photos.length]);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
    const handleNextPress = () => {
        let newPhotoIndex: number;
        if (selectedPhoto?.index === photos.length - 1) {
            newPhotoIndex = 0;
        } else {
            newPhotoIndex = selectedPhoto ? selectedPhoto?.index + 1 : 0;
        }

        setSelectedPhoto({
            img: photos[newPhotoIndex],
            index: newPhotoIndex
        })
    };
    const handlePreviousPress = () => {
        let newPhotoIndex: number;
        if (selectedPhoto?.index === 0) {
            newPhotoIndex = photos.length - 1;
        } else {
            newPhotoIndex = selectedPhoto ? selectedPhoto?.index - 1 : 0;
        }

        setSelectedPhoto({
            img: photos[newPhotoIndex],
            index: newPhotoIndex
        });
    };

    return (
        <div className="container">
            {photos.map((img, index) => (
                <img key={index}
                     onClick={() => {
                        setSelectedPhoto({ img: img, index });
                        handleShow();
                }} 
                    className={'student-work-image'} 
                    data-toggle="modal" 
                    data-target="#myLargeModalLabel" 
                    alt="student"
                    src={img} />
            ))}

            <div className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog" id={'myLargeModalLabel'} aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                    </div>
                </div>
            </div>
            <PhotoZoom source={selectedPhoto?.img || ""}
                isOpen={showModal}
                handleClose={handleClose}
                onNextPress={handleNextPress}
                onPreviousPress={handlePreviousPress} />
        </div>
    );
}

export default StudentWork;